import { getBearerToken } from '@/context/TrackOticAuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

export async function qrFetch(path, options = {}) {
  const token = getBearerToken();
  const res = await fetch(`${API}/api${path}`, {
    credentials: 'include',
    redirect: 'manual',
    ...options,
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...(options.headers || {}) },
  });
  if (res.type === 'opaqueredirect' || res.status === 302) {
    // Phase 6 (POD_KIND=bfsi): public routes are closed; the API sends anonymous callers to login
    const err = new Error('login required'); err.status = 302; err.loginRequired = true; throw err;
  }
  let body = null;
  try { body = await res.json(); } catch { /* empty */ }
  if (!res.ok) {
    const err = new Error(typeof body?.detail === 'string' ? body.detail : `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return body;
}

export const qrGetPublic = (path) => qrFetch(path);
export const qrPostPublic = (path, body) => qrFetch(path, { method: 'POST', body: JSON.stringify(body || {}) });

/** Extract a passport token from a scanned QR payload (full URL or bare token). */
export function passportTokenFrom(text) {
  const m = /\/p\/([0-9A-HJKMNP-TV-Z]{20})\b/i.exec(text || '');
  if (m) return m[1].toUpperCase();
  return /^[0-9A-HJKMNP-TV-Z]{20}$/i.test((text || '').trim()) ? text.trim().toUpperCase() : null;
}

export function safeNext(next) {
  return next && next.startsWith('/') && !next.startsWith('//') ? next : '/';
}

let _podConfig = null;
/** Cached public pod flags (public_routes, location_required, session_hours). */
export async function getPodConfig() {
  if (!_podConfig) _podConfig = await qrFetch('/qr/pod-config').catch(() => ({ public_routes: true, location_required: false }));
  return _podConfig;
}
